/** @jsx jsx */
import React from 'react'
import { jsx, Flex, Box } from 'theme-ui'
import Heading from '../shared/Typography/Heading/Heading'
import Body from '../shared/Typography/Body/Body'
import styled from '@emotion/styled'
import CustomStarRating from '../shared/StarRating/StarRating'
import { Fragment } from 'react'
import ThumbsUp from '../../icons/ThumbsUp.svg'
import { useWindowSize } from '../../hooks/useWindowSize'
import Checkmark from '../../icons/CheckmarkIcon.svg'

const CommentSection = styled.div``

const CommentHeader = styled(Flex)`
  flex-direction: column;
  padding: 25px;
  padding-right: 10px;
  justify-content: flex-start;
`

const RecommendThisProduct = () => {
  return (
    <Body
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        p: '6px',
        pl: 0,
      }}
    >
      <img sx={{ height: '14px', width: '14px', mr: '8px' }} src={ThumbsUp} />I
      recommend this product
    </Body>
  )
}

const CommentInfo = styled(Flex)``

const ImageCircle = ({ clientName, ...props }) => {
  if (!clientName) return null
  let name = clientName.split(' ')
  const firstLetter = name[0] ? name[0].charAt(0).toUpperCase() : null
  const secondLetter = name[1] ? name[1].charAt(0).toUpperCase() : null

  const circle = {
    backgroundColor: 'black',
    width: '79px',
    height: '79px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  }

  return (
    <div style={circle}>
      <span style={{ color: 'white' }}>
        {firstLetter} {secondLetter}
      </span>
      <img
        sx={{ position: 'absolute', bottom: '-2px', right: '0px', width: 20 }}
        src={Checkmark}
      />
    </div>
  )
}

const CommentBlock = props => {
  const { smallScreen } = useWindowSize()
  if (!props.commentText && !props.clientName) {
    return <Fragment />
  }

  return (
    <Flex
      sx={{
        flexDirection: ['column', null, null, 'row'],
        flexWrap: 'wrap',
        padding: '20px',
        my: 25,
        border: 'commentBorder',
        ...props.style,
      }}
    >
      <CommentInfo
        sx={{
          width: ['100%', '100%', null, '330px'],
          flexDirection: 'column',
        }}
      >
        <Flex sx={{ alignItems: 'center', pb: 20 }}>
          <ImageCircle clientName={props.clientName} />
          <CommentHeader>
            <Heading
              as="h6"
              variant="bold"
              sx={{
                textTransform: 'uppercase',
              }}
            >
              {props.clientName}
            </Heading>

            <Body
              variant="body3"
              sx={{
                color: '#00b67a',

                mt: '2px',
              }}
            >
              {props.isTrustPilot ? 'TRUSTPILOT REVIEW' : 'VERIFIED BUYER'}
            </Body>
            {smallScreen && <RecommendThisProduct />}
          </CommentHeader>
        </Flex>
        {!smallScreen && <RecommendThisProduct />}
      </CommentInfo>

      <Flex
        sx={{
          flexDirection: 'column',
          flex: 1,
          width: ['100%', '100%', null, 'auto'],
          borderLeft: ['none', 'none', null, 'commentBorder'],
          padding: ['none', 'none', null, '0px 25px'],
        }}
      >
        <CommentSection>
          {props.stars && (
            <CustomStarRating
              name="commentBlockRating"
              rating={props.stars}
              starDimension="25px"
            />
          )}
          <Heading
            as="h6"
            variant="bold"
            sx={{ textTransform: 'uppercase', my: '12px' }}
          >
            {props.commentTitle}
          </Heading>
          {props.commentText && (
            <Body variant="body2">{props.commentText}</Body>
          )}
          {props.reply && (
            <Box sx={{ p: 25, bg: 'lighterGray', mt: '20px' }}>
              <Heading sx={{ mb: '5px' }} variant="bold" as="h6">
                JAXXON TEAM
              </Heading>
              <Body variant="body2">{props.reply}</Body>
            </Box>
          )}
        </CommentSection>
      </Flex>
    </Flex>
  )
}

export default CommentBlock
